// extracted by mini-css-extract-plugin
export default {"classesRow":"EditionsCarousel_classesRow__+FLwJ","empty":"EditionsCarousel_empty__Q-izb","edition-carousel":"EditionsCarousel_edition-carousel__41vNR"};